import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../index';

interface Zoom {
    zoom: number;
}

const initialState: Zoom = {
    zoom: 1
};

export const zoomSlice = createSlice({
    name: 'zoom',
    initialState,
    reducers: {
        increment: state => {
            if (state.zoom !== 2.6) {
                state.zoom = Math.round((state.zoom + 0.4) * 100) / 100;
            }
            return;
        },
        decrement: state => {
            if (state.zoom !== 0.6) {
                state.zoom = Math.round((state.zoom - 0.4) * 100) / 100;
            }
            return;
        },
        setZoom: (state, { payload: { value } }: PayloadAction<{ value: number }>) => {
            state.zoom = Math.round(value * 100) / 100;
        }
    }
});

export const { increment, decrement, setZoom } = zoomSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selecZoom = (state: RootState) => state.zoom.zoom;

export default zoomSlice.reducer;
